import React, { useState, useEffect, useContext } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import { useTranslation } from "react-i18next";
import PermissionContext from '../../contexts/PermissionContext';
import DateFnsUtils from '@date-io/date-fns';
import { parseISO, format } from 'date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { alpha } from '@material-ui/core/styles';

const validationSchema = yup.object().shape({
    effective_date: yup
        .date('Enter a date')
        .nullable(),
    employee_id: yup
        .number('Select a payrroll concept')
        .nullable(),
    concept_id: yup
        .number('Select a payrroll concept')
        .nullable(),
    description: yup
        .string('Enter a description'),
    prqtty: yup
        .number('Enter a quantity')
        .nullable(),
    allowance: yup
        .number('Enter an allowance')
        .nullable(),
    deduction: yup
        .number('Enter an deduction')
        .nullable(),
});


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(18),
        maxWidth: 800,
        margin: 'auto',
        overflow: 'hidden',
        backgroundColor: 'white'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {

        margin: theme.spacing(3, 2, 2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));



const endpoint = `pr-employee-move`
const PRConceptEndpoint = 'pr-concept'
const employeeEndpoint = 'profesional'
const conceptGetValueEnpoint = 'pr-concept/get-value'
const DATE_FORMAT = 'yyyy-MM-dd';

const PREmployeeMoveForm = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const { idToUpdate, permission } = props;

    const { userHasPermission } = useContext(PermissionContext)

    // console.log("UHP",userHasPermission)

    let hasPerm = userHasPermission(permission, 'can_list')
    let hasAddPerm = userHasPermission(permission, 'can_post')
    let hasEditPerm = userHasPermission(permission, 'can_patch')
    let hasGetPerm = userHasPermission(permission, 'can_get')
    let hasDeletePerm = userHasPermission(permission, 'can_delete')
    // for detail form
    let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')

    const [effectiveDate, setEffectiveDate] = useState(new Date());

    //Pr employee data
    const [employeeData, setEmployeeData] = useState([]);
    useEffect(() => {

        retrieveEmployeeDataData()
    }, []); // Those ARE connectec

    const retrieveEmployeeDataData = () => {
        DataService.getAll(employeeEndpoint)
            .then(response => {
                setEmployeeData(response.data)
                // console.log(response.data);
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }
    const [employeeValue, setEmployeeValue] = React.useState(employeeData[0]);
    const [employeeInputValue, setEmployeeInputValue] = React.useState('');

    //Pr concept data
    const [prconceptData, setPRConceptData] = useState([]);
    useEffect(() => {

        retrievePRConceptDataData()
    }, []); // Those ARE connectec

    const retrievePRConceptDataData = () => {
        DataService.getAll(PRConceptEndpoint)
            .then(response => {
                setPRConceptData(response.data)
                // console.log(response.data);
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }

    const [prconceptValue, setPRConceptValue] = React.useState(prconceptData[0]);
    const [prconceptInputValue, setPRConceptInputValue] = React.useState('');

    const retrieveConceptValueData = () => {
        DataService.getAll(PRConceptEndpoint)
            .then(response => {
                setPRConceptData(response.data)
                // console.log(response.data);
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }


    const [allowance, setAllowance] = useState(0);
    const [deduction, setDeduction] = useState(0);
    const [prqttyInputValue, setPRQttyInputValue] = useState("");
    const [prqtty, setPRQtty] = useState(1);
    useEffect(() => {
        if (prconceptValue && employeeValue) {
            if ('id' in prconceptValue && 'id' in employeeValue) retrieveConceptValue()
        }

    }, [prqtty]);

    const retrieveConceptValue = () => {
        // console.log(`Values: ${prconceptValue} / ${employeeValue}`);
        DataService.getAll(`${conceptGetValueEnpoint}/${prconceptValue.id}/${employeeValue.id}`)
            .then(response => {
                // setPRConceptData(response.data)
                // console.log(response.data);
                setAllowance(prconceptValue ? prconceptValue.code.startsWith('A', 0) ? response.data.value * prqtty : 0 : 0)
                setDeduction(prconceptValue ? prconceptValue.code.startsWith('D', 0) ? response.data.value * prqtty : 0 : 0)

            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }

    // INFO NOTIFICATION VARS
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoBody, setInfoBody] = useState('');
    //***********************

    //Dialog Vars
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogueTitle, setDialogueTitle] = useState('');
    const [dialogueBody, setDialogueBody] = useState('');
    //**********

    // DIALOG FUNCTIONS
    const handleDialogOk = () => {
        setDialogOpen(false)
    };

    const handleDialogClose = () => {
        setDialogOpen(false)
    };

    const openDialogBox = (title, body) => {
        setDialogueTitle(title)
        setDialogueBody(body)
        setDialogOpen(true)
    };
    //*******************

    // Notification INFO functions
    const openNoticeBox = (title, body) => {
        setInfoTitle(title)
        setInfoBody(body)
        setInfoOpen(true)
    };

    const handleInfoClose = () => {
        setInfoOpen(false)
    };
    // *****************

    const emptyData = {
        'effective_date': '',
        'description': '',
        'allowance': 0.00,
        'deduction': 0.00,
        'concept_id': 0,
        'employee_id': 0,
        'prqtty': 1,
    }

    const [data, setData] = useState(emptyData);
    useEffect(() => {
        let id = typeof idToUpdate === 'object' ? 0 : idToUpdate
        getData(id)
    }, []);

    const getData = (id) => {
        DataService.get(id, endpoint)
            .then(response => {
                // console.log("data get", response.data)
                setData(response.data)
                setPRConceptValue(response.data.concept)
                setEmployeeValue(response.data.employee)
                setEffectiveDate(parseISO(response.data.effective_date))
                setPRQtty(response.data.qtty)
                setAllowance(response.data.allowance)
                setDeduction(response.data.deduction)

            })
            .catch(e => {
                if (e.response.status != '404') {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
                    // setData(emptyData)
                } else {
                    setData(emptyData)
                }

            });
    }

    const updateData = (values) => {
        let newValues = { ...values }
        newValues.employee_id = employeeValue.id
        newValues.concept_id = prconceptValue.id
        newValues.effective_date = format(effectiveDate, DATE_FORMAT)
        newValues.qtty = prqtty
        newValues.allowance = allowance
        newValues.deduction = deduction
        // console.log("newValues", newValues)
        DataService.update(endpoint, newValues)
            .then(response => {
                openNoticeBox("Notice", t("record_updated_successfully", { "table": t("menu_pr_type") }))
                setData(emptyData)
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }

    const addData = (values) => {
        let newValues = {
            concept_id: prconceptValue.id,
            employee_id: employeeValue.id,
            qtty: prqtty,
            effective_date: format(effectiveDate, DATE_FORMAT),
            allowance: allowance,
            deduction: deduction,
            description: values.description
        }
        DataService.create(endpoint, newValues)
            .then(response => {
                openNoticeBox("Notice", t("record_created_successfully", { "table": t("menu_employee_move") }))
                setData(emptyData)
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: data,
        validationSchema: validationSchema,
        onReset: () => {
        },
        onSubmit: (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            if (typeof idToUpdate === 'object') {
                addData(values)
                resetForm()
            }
            if (typeof idToUpdate === 'number') {
                // console.log("submit update",values)
                values.id = idToUpdate
                updateData(values)
            }

        },
    });
    const classes = useStyles();
    return (
        <Paper className={classes.paper}>
            <CssBaseline />
            <GenericDialogBox
                opn={dialogOpen}
                handleDialogOk={handleDialogOk}
                handleDialogClose={handleDialogClose}
                title={dialogueTitle}
                body={dialogueBody} />
            <InfoBox
                opn={infoOpen}
                handleDialogClose={handleInfoClose}
                title={infoTitle}
                body={infoBody} />

            <form className={classes.form} onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                clearable="true"
                                value={effectiveDate}
                                placeholder="2021-07-07"
                                onChange={date => setEffectiveDate(date)}
                                // minDate={new Date()}
                                format={DATE_FORMAT}
                                autoOk
                                name="effective_date"
                                id="effective_date"
                                variant="inline"
                                inputVariant="outlined"
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={8}>
                        <Autocomplete
                            id="employee_id"
                            name="employee_id"
                            // value={value}
                            options={employeeData}
                            getOptionLabel={(option) => option.name ? option.name : "-"}
                            onChange={(event, newValue) => {
                                // console.log("newValue", newValue)
                                setEmployeeValue(newValue);
                            }}
                            inputValue={employeeInputValue}
                            onInputChange={(event, newInputValue) => {
                                // console.log("change", newInputValue)
                                setEmployeeInputValue(newInputValue);
                            }}

                            value={employeeValue ? employeeValue : ""}
                            renderInput={(params) => <TextField {...params} label={t("pr_employee_move_form_employee")} variant="outlined" />}
                            getOptionSelected={(option, value) => option.value === value.value}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            id="concept_id"
                            name="concept_id"
                            // value={value}
                            options={prconceptData}
                            getOptionLabel={(option) => option.name ? option.name : "-"}
                            onChange={(event, newValue) => {
                                // console.log("newValue", newValue)
                                setPRConceptValue(newValue);
                            }}
                            inputValue={prconceptInputValue}
                            onInputChange={(event, newInputValue) => {
                                // console.log("change", newInputValue)
                                setPRConceptInputValue(newInputValue);
                            }}

                            value={prconceptValue ? prconceptValue : ""}
                            renderInput={(params) => <TextField {...params} label={t("pr_employee_move_form_concept")} variant="outlined" />}
                            getOptionSelected={(option, value) => option.value === value.value}
                            style={{ marginTop: '15px' }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="description"
                            label="Descripcion"
                            name="description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            error={formik.touched.description && Boolean(formik.errors.description)}
                            helperText={formik.touched.description && formik.errors.description}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="prqtty"
                            label="Cantidad"
                            name="prqtty"
                            value={prqtty}
                            onChange={(event, newValue) => {
                                // console.log("newValue", event.target.value, newValue)
                                setPRQtty(event.target.value);
                            }}
                            error={formik.touched.prqtty && Boolean(formik.errors.prqtty)}
                            helperText={formik.touched.prqtty && formik.errors.prqtty}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="allowance"
                            label="Asignacion"
                            name="allowance"
                            value={allowance}
                            onChange={(event, newValue) => {
                                // console.log("newValue", event.target.value, newValue)
                                setAllowance(event.target.value);
                            }}
                            error={formik.touched.allowance && Boolean(formik.errors.allowance)}
                            helperText={formik.touched.allowance && formik.errors.allowance}
                            disabled={prconceptValue ? prconceptValue.code.startsWith('D', 0) ? true : false : true}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="deduction"
                            label="Deduccion"
                            name="deduction"
                            value={deduction}
                            onChange={(event, newValue) => {
                                // console.log("newValue", event.target.value, newValue)
                                setDeduction(event.target.value);
                            }}
                            error={formik.touched.deduction && Boolean(formik.errors.deduction)}
                            helperText={formik.touched.deduction && formik.errors.deduction}
                            disabled={prconceptValue ? prconceptValue.code.startsWith('A', 0) ? true : false : true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            disabled={typeof idToUpdate === 'object' && hasAddPerm ? false : hasEditPerm ? false : true}
                        >
                            {typeof idToUpdate === 'object' ? t("save_form_button") : t("update_form_button")}
                        </Button>
                    </Grid>

                </Grid>
            </form>

            <Box mt={8}>

            </Box>
        </Paper>
    )
})

export default PREmployeeMoveForm;
